import { inject, Injectable, NgZone, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { isPlatformBrowser } from '@angular/common';
import { filter } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GoogleAnalyticsService {
  private readonly _router = inject(Router);
  private readonly _zone = inject(NgZone);
  private readonly _platformId = inject(PLATFORM_ID);
  private readonly _gTag = environment.gTag;

  init() {
    if (!isPlatformBrowser(this._platformId) || !this._gTag) return;

    const exists = document.querySelector(
      `script[src*="googletagmanager.com/gtag/js?id=${this._gTag}"]`
    );

    if (!exists) {
      const s = document.createElement('script');
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${this._gTag}`;
      document.head.appendChild(s);
    }

    (globalThis as any).dataLayer = (globalThis as any).dataLayer ?? [];
    (globalThis as any).gtag =
      (globalThis as any).gtag ??
      function gtag() {
        (globalThis as any).dataLayer.push(arguments);
      };

    (globalThis as any).gtag('js', new Date());
    (globalThis as any).gtag('config', this._gTag);

    this._zone.runOutsideAngular(() => {
      this._router.events
        .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
        .subscribe((e) => {
          (globalThis as any).gtag?.('config', this._gTag, {
            page_path: e.urlAfterRedirects,
          });
        });
    });
  }

  event(name: string, params: Record<string, unknown> = {}): void {
    (globalThis as any).gtag?.('event', name, params);
  }
}
